import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoasParameterService {

  private url = environment.api + "api/erp/coas-parameter";
    
    constructor(
      private http: HttpClient,
    ) { }
  
    getCoasParameters(){
      return this.http.get(this.url);
    }

    createParameter(data: any) {
      return this.http.post(this.url, data);
    }

    createProductParameter(data: any) {
      return this.http.post(this.url + "/product", data);
    }

    updateParameter(data: any, coasParameterId: number) {
      return this.http.put(this.url + `/${coasParameterId}`, data);
    }

    deleteParameter(coasParameterId: number) {
      return this.http.delete(this.url + `/${coasParameterId}`);
    }

    getProductParameters(productId: number) {
      return this.http.get(this.url + `/product/${productId}`);
    }

    getAssigProductParameters(value: string) {
      return this.http.get(this.url + `/product-parameter`);
    }
    
    getAssigProviderProductParameters(searchValue: any) {
      return this.http.get(this.url + `/product-parameter-providers`,
        {
          params: {
            searchValue: searchValue,
          }
        }
      );
    }

    getIsExisteAssign(parameterId: any, providerId: any, productId: any) {
      return this.http.get(this.url + `/${parameterId}/providers/${providerId}/products/${productId}`);
    }

    getAssignments(providerId: any, productId: any) {
      return this.http.get(this.url + `/providers/${providerId}/products/${productId}`);
    }

    deleteProductParameters(productCoasParameterId: any) {
      return this.http.delete(this.url + `/product-parameter/${productCoasParameterId}`);
    }

    createTemplate(data: any) {
      return this.http.post(this.url + "/template", data);
    }

    getTemplates(filter?: string) {
      return this.http.get(this.url + "/template", {
        params: filter ? { filter } : {}
      });
    }

    updateTemplate(templateId: number, data: any) {
      return this.http.put(this.url + `/template/${templateId}`, data);
    }

    deleteTemplate(templateId: number) {
      return this.http.delete(this.url + `/template/${templateId}`);
    }
    
    deleteParameterFromTemplate(templateId: number, parameterId: number) {
      return this.http.delete(
        this.url + `/template/${templateId}/parameter/${parameterId}`
      );
    }

    createProductParameterByTemplate(data: any) {
      return this.http.post(this.url + "/product-by-template", data);
    }
}
